import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  auctionList: [],
  isAuctionLoading: true,
};

const auctionSlice = createSlice({
  name: "auction",
  initialState,
  reducers: {
    setAuctionData(state, action) {
      state.auctionList = action.payload;
      state.isAuctionLoading = false;
    },
    removeAuctionData(state, action) {
      state.auctionList = [];
      state.isAuctionLoading = true;
    },
  },
});
export const { setAuctionData, removeAuctionData } = auctionSlice.actions;
export default auctionSlice.reducer;
